// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609250104/js/" + chunkId + "." + {"44":"06cc5708","225":"29e8e0c4","481":"44ce6318","486":"8558a9f7","770":"2bec6503"}[chunkId] + ".0.9357282848377265.chunk.js";
};